import angular from 'angular';

angular.module('dashboard').controller('DepositorConfirmModalCtrl', [
    '$scope',
    '$uibModalInstance',
    function($scope, $uibModalInstance) {
        $scope.includes = {
            formMessages: require('../../../common/form-messages.html')
        };

        $scope.close = function() {
            $uibModalInstance.dismiss();
        };

        $scope.valid = function() {
            if ($scope.form.$valid) {
                $uibModalInstance.close($scope.motif);
            }
        };
    }
]);
